/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { KeysOf } from "#app/composables/asyncData";
import { isMocked, mockPath } from "#root/api/util/mocking";
import type { ApiOptions, UseApiOptions } from "../http-client";
import { HttpClient } from "../http-client";
import type {
  AddAddressData,
  AddAddressPayload,
  CancelOrderData,
  CancelOrderPayload,
  CreateProfileData,
  CreateSmsSubscriptionData,
  DeleteAddressData,
  DeletePaymentInstrumentData,
  EventRegistrationDataData,
  EventRegistrationDataPayload,
  GetLoyaltyActivitiesData,
  GetLoyaltyOffersData,
  GetLoyaltyReferralsData,
  GetLoyaltyTokenData,
  GetLoyaltyTokenPayload,
  GetLoyaltyVouchersData,
  GetLoyaltyWelcomePromoStatusData,
  GetOrderDetailsData,
  GetOrderHistoryData,
  GetOrderHistoryPayload,
  GetPaymentInstrumentsData,
  GetProfileInfoData,
  GetSmsSubscriptionInfoData,
  InvoiceDownloadData,
  InvoiceDownloadPayload,
  LookupData,
  LookupPayload,
  NotifyMobileData,
  NotifyMobilePayload,
  ProfileInfoPayload,
  ResendGiftcardEmailData,
  ResendGiftcardEmailPayload,
  RetrieveUserDataData,
  RetrieveUserDataPayload,
  ReturnLabelData,
  SavePaymentInstrumentData,
  SavePaymentInstrumentPayload,
  TrackOrderData,
  TrackOrderPayload,
  UpdateAddressData,
  UpdateAddressPayload,
  UpdatePaymentInstrumentData,
  UpdatePaymentInstrumentPayload,
  UpdateProfileData,
  UpdateSmsSubscriptionData,
} from "./data-contracts";

export class Consumer extends HttpClient {
  static paths = {
    getProfileInfo: "/consumers-v3/consumer",
    updateProfile: "/consumers-v3/consumer",
    createProfile: "/consumers-v3/consumer",
    getLoyaltyActivities: "/consumers-v3/consumer/loyalty/activities2",
    getLoyaltyOffers: "/consumers-v3/consumer/loyalty/offers",
    getLoyaltyReferrals: "/consumers-v3/consumer/loyalty/referrals",
    getLoyaltyToken: "/consumers-v3/consumer/loyalty/token",
    getLoyaltyWelcomePromoStatus:
      "/consumers-v3/consumer/loyalty/promo/welcome",
    getLoyaltyVouchers: "/consumers-v3/consumer/loyalty/vouchers",
    lookup: "/consumers-v3/consumer/lookup",
    getSmsSubscriptionInfo: "/consumers-v3/consumer/subscription",
    updateSmsSubscription: "/consumers-v3/consumer/subscription",
    createSmsSubscription: "/consumers-v3/consumer/subscription",
    getPaymentInstruments: "/consumers-v3/consumer/payment_instruments",
    savePaymentInstrument: "/consumers-v3/consumer/payment_instruments",
    updatePaymentInstrument:
      "/consumers-v3/consumer/payment_instruments/:paymentInstrumentId",
    deletePaymentInstrument:
      "/consumers-v3/consumer/payment_instruments/:paymentInstrumentId",
    getOrderDetails: "/consumers-v3/consumer/purchase/:orderId",
    invoiceDownload: "/consumers-v3/consumer/purchase/invoice/download",
    getOrderHistory: "/consumers-v3/consumer/purchasehistory",
    returnLabel: "/consumers-v3/consumer/return/:orderId/returnLabel",
    trackOrder: "/consumers-v3/consumer/TrackOrder",
    addAddress: "/consumers-v3/consumer/address",
    updateAddress: "/consumers-v3/consumer/address/:addressId",
    deleteAddress: "/consumers-v3/consumer/address/:addressId",
    cancelOrder: "/consumers-v3/consumer/CancelOrder",
    resendGiftcardEmail: "/consumers-v3/consumer/resendGiftCardEmail",
    retrieveUserData: "/consumers-v3/consumer/retrieveUserData",
    notifyMobile: "/consumers-v3/consumer/notification",
    eventRegistrationData: "/consumers-v3/consumer/event-registration",
  };
  static mockDataPaths = { getLoyaltyVouchers: "vouchers" };
  static mockedPaths = {
    getProfileInfo: false,
    updateProfile: false,
    createProfile: false,
    getLoyaltyActivities: false,
    getLoyaltyOffers: false,
    getLoyaltyReferrals: false,
    getLoyaltyToken: false,
    getLoyaltyWelcomePromoStatus: false,
    getLoyaltyVouchers: false,
    lookup: false,
    getSmsSubscriptionInfo: false,
    updateSmsSubscription: false,
    createSmsSubscription: false,
    getPaymentInstruments: false,
    savePaymentInstrument: false,
    updatePaymentInstrument: false,
    deletePaymentInstrument: false,
    getOrderDetails: false,
    invoiceDownload: false,
    getOrderHistory: false,
    returnLabel: false,
    trackOrder: false,
    addAddress: false,
    updateAddress: false,
    deleteAddress: false,
    cancelOrder: false,
    resendGiftcardEmail: false,
    retrieveUserData: false,
    notifyMobile: false,
    eventRegistrationData: false,
  };
  static onResponseHandlers = {};
  constructor(baseParams) {
    super(baseParams, "Api");
  }

  /**
   * No description
   *
   * @tags Consumer
   * @name GetProfileInfo
   * @summary Get Profile
   * @request GET:/consumers-v3/consumer
   */
  getProfileInfo = <
    ResT = GetProfileInfoData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    query?: {
      /** @default false */
      includeLoyaltySummary?: boolean;
    },
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer")
        ? computed(() => mockPath("Consumer", "getProfileInfo", ``))
        : computed(() => `/consumers-v3/consumer`),
      method: "GET",
      query: query,
      format: "json",
      key: `/consumers-v3/consumer`,
      apiName: "Consumer.getProfileInfo",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetProfileInfo
   * @summary Get Profile
   * @request GET:/consumers-v3/consumer
   */
  $getProfileInfo = (
    query?: {
      /** @default false */
      includeLoyaltySummary?: boolean;
    },
    requestParams: ApiOptions = {},
  ) =>
    this.$request<GetProfileInfoData>({
      path: isMocked("/consumers-v3/consumer")
        ? mockPath("Consumer", "getProfileInfo", ``)
        : `/consumers-v3/consumer`,
      method: "GET",
      query: query,
      format: "json",
      apiName: "Consumer.getProfileInfo",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name UpdateProfile
   * @summary Update Profile
   * @request PUT:/consumers-v3/consumer
   */
  updateProfile = <
    ResT = UpdateProfileData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: ProfileInfoPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer")
        ? computed(() => mockPath("Consumer", "updateProfile", ``))
        : computed(() => `/consumers-v3/consumer`),
      method: "PUT",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer`,
      apiName: "Consumer.updateProfile",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name UpdateProfile
   * @summary Update Profile
   * @request PUT:/consumers-v3/consumer
   */
  $updateProfile = (data: ProfileInfoPayload, requestParams: ApiOptions = {}) =>
    this.$request<UpdateProfileData>({
      path: isMocked("/consumers-v3/consumer")
        ? mockPath("Consumer", "updateProfile", ``)
        : `/consumers-v3/consumer`,
      method: "PUT",
      body: data,
      format: "json",
      apiName: "Consumer.updateProfile",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name CreateProfile
   * @summary Create Profile
   * @request POST:/consumers-v3/consumer
   */
  createProfile = <
    ResT = CreateProfileData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: ProfileInfoPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer")
        ? computed(() => mockPath("Consumer", "createProfile", ``))
        : computed(() => `/consumers-v3/consumer`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer`,
      apiName: "Consumer.createProfile",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name CreateProfile
   * @summary Create Profile
   * @request POST:/consumers-v3/consumer
   */
  $createProfile = (data: ProfileInfoPayload, requestParams: ApiOptions = {}) =>
    this.$request<CreateProfileData>({
      path: isMocked("/consumers-v3/consumer")
        ? mockPath("Consumer", "createProfile", ``)
        : `/consumers-v3/consumer`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.createProfile",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyActivities
   * @summary Get Loyalty Activities
   * @request GET:/consumers-v3/consumer/loyalty/activities2
   */
  getLoyaltyActivities = <
    ResT = GetLoyaltyActivitiesData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    query?: {
      /** Comma-separated activity type names to filter by type/s */
      activity_types?: string;
      /**
       * alltime - Activities all time \
       * ytd - Year to date \
       * prev<n>ytd - Year to date of previous n years e.g. prev1ytd. If today is 05/05/2017, then it would be 01/01/2016-05/05/2016. Used for period-to-period comparison. \
       * mtd - Month to date \
       * prev<n>mtd - Same period as mtd but of previous n months e.g. prev1mtd. If today is 05/05/2017, then it would be 04/01/2017-04/05/2017. Used for period-to-period comparison. \
       * wtd - Week to date, starts on a Monday \
       * prev<n>wtd - Same period as wtd but of previous n weeks e.g. prev1wtd. If today is 05/05/2017 (Friday), then it would be 04/24/2017-04/28/2017 (Monday to Friday). Used for period-to-period comparison. \
       * qtd - Quarter to date \
       * prev<n>qtd - Same period as qtd but of previous n quarters e.g. prev1qtd. If today is 05/05/2017, then it would be 01/01/2017-02/05/2017 since previous quarter is from January to March. Used for period-to-period comparison. \
       * last<n>d - Last n days; e.g. last5d \
       * last<n>w - Last n weeks; e.g. last3w \
       * last<n>m - Last n months; e.g. last2m \
       * prev<n>d - Previous n days; e.g. prev5d. The 5 days before the last 5 days. Used for period-to-period comparison. \
       * prev<n>w - Previous n weeks; e.g. prev5w. The 5 weeks before the last 5 weeks. Used for period-to-period comparison. \
       * prev<n>m - Previous n months; e.g. prev5m. The 5 months before the last 5 minths. Used for period-to-period comparison.
       * @default "last3m"
       */
      period?: string;
      /** Specify start date, i.e. 2014-01-01 */
      period_start?: string;
      /** Specify end date, i.e. 2014-01-01 */
      period_end?: string;
      /** @default false */
      with_details?: boolean;
      /** @default false */
      with_line_item?: boolean;
      /** List of metric names either CSV string or array */
      earned_metrics?: string | string[];
      /** @default false */
      with_metric_change?: boolean;
      /**
       * Offset page parameter
       * @default 1
       */
      page?: number;
      /**
       * Number of items per page
       * @default 15
       */
      per_page?: number;
    },
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/loyalty/activities2")
        ? computed(() => mockPath("Consumer", "getLoyaltyActivities", ``))
        : computed(() => `/consumers-v3/consumer/loyalty/activities2`),
      method: "GET",
      query: query,
      format: "json",
      key: `/consumers-v3/consumer/loyalty/activities2`,
      apiName: "Consumer.getLoyaltyActivities",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyActivities
   * @summary Get Loyalty Activities
   * @request GET:/consumers-v3/consumer/loyalty/activities2
   */
  $getLoyaltyActivities = (
    query?: {
      /** Comma-separated activity type names to filter by type/s */
      activity_types?: string;
      /**
       * alltime - Activities all time \
       * ytd - Year to date \
       * prev<n>ytd - Year to date of previous n years e.g. prev1ytd. If today is 05/05/2017, then it would be 01/01/2016-05/05/2016. Used for period-to-period comparison. \
       * mtd - Month to date \
       * prev<n>mtd - Same period as mtd but of previous n months e.g. prev1mtd. If today is 05/05/2017, then it would be 04/01/2017-04/05/2017. Used for period-to-period comparison. \
       * wtd - Week to date, starts on a Monday \
       * prev<n>wtd - Same period as wtd but of previous n weeks e.g. prev1wtd. If today is 05/05/2017 (Friday), then it would be 04/24/2017-04/28/2017 (Monday to Friday). Used for period-to-period comparison. \
       * qtd - Quarter to date \
       * prev<n>qtd - Same period as qtd but of previous n quarters e.g. prev1qtd. If today is 05/05/2017, then it would be 01/01/2017-02/05/2017 since previous quarter is from January to March. Used for period-to-period comparison. \
       * last<n>d - Last n days; e.g. last5d \
       * last<n>w - Last n weeks; e.g. last3w \
       * last<n>m - Last n months; e.g. last2m \
       * prev<n>d - Previous n days; e.g. prev5d. The 5 days before the last 5 days. Used for period-to-period comparison. \
       * prev<n>w - Previous n weeks; e.g. prev5w. The 5 weeks before the last 5 weeks. Used for period-to-period comparison. \
       * prev<n>m - Previous n months; e.g. prev5m. The 5 months before the last 5 minths. Used for period-to-period comparison.
       * @default "last3m"
       */
      period?: string;
      /** Specify start date, i.e. 2014-01-01 */
      period_start?: string;
      /** Specify end date, i.e. 2014-01-01 */
      period_end?: string;
      /** @default false */
      with_details?: boolean;
      /** @default false */
      with_line_item?: boolean;
      /** List of metric names either CSV string or array */
      earned_metrics?: string | string[];
      /** @default false */
      with_metric_change?: boolean;
      /**
       * Offset page parameter
       * @default 1
       */
      page?: number;
      /**
       * Number of items per page
       * @default 15
       */
      per_page?: number;
    },
    requestParams: ApiOptions = {},
  ) =>
    this.$request<GetLoyaltyActivitiesData>({
      path: isMocked("/consumers-v3/consumer/loyalty/activities2")
        ? mockPath("Consumer", "getLoyaltyActivities", ``)
        : `/consumers-v3/consumer/loyalty/activities2`,
      method: "GET",
      query: query,
      format: "json",
      apiName: "Consumer.getLoyaltyActivities",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyOffers
   * @summary Get Loyalty Offers
   * @request GET:/consumers-v3/consumer/loyalty/offers
   */
  getLoyaltyOffers = <
    ResT = GetLoyaltyOffersData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    query?: {
      /** Internal name of a known Offer Set */
      set?: string;
      /** Internal name of a known Placement */
      placement?: string;
      /** Internal name of a known Campaign */
      campaign?: string;
      /** Whether the response should be paginated */
      pagination?: boolean;
      /** Start index of the available Offers subset. Used in conjunction with set. */
      start_index?: number;
      /** End index of the available Offers subset. Used in conjunction with set. */
      end_index?: number;
      /** Comma-separated string of category internal names of Offers to include in the response */
      category?: string;
      /** The content layout name. Default is the access token's application name. Example: ios, android */
      layout?: string;
      /** Return only matching offer_types based on offer_type parameter. Can be any of 'barcode', 'certificate', 'coupon', 'url' or 'stellar'. */
      offer_type?: "barcode" | "certificate" | "coupon" | "url" | "stellar";
      /** If set to true, only offers that can be responded to will be shown. */
      respondable?: boolean;
      /** If set to true, will show clipped and unclipped offers, false will show unclipped offers only */
      show_clipped?: boolean;
      /** If set to true, targetable attribute that holds a target offer object will be shown. */
      show_target?: boolean;
      /** Comma-separated string of processing status to be included in the response */
      displayable_processing_statuses?: string;
      /** If set to true, is_clipped attribute will be shown. */
      include_clipped?: boolean;
      /** If set to true, responses(Array) attribute that holds responses details will be shown. */
      include_responses?: boolean;
      /** Values can be true or false. This parameter will return the category keys of the offer in an array. */
      result_with_categories?: boolean;
      /** If set to true, html attribute that holds html layout will be shown. */
      html?: boolean;
      /**
       * Sort options. Values can be updated_at or publish_date or name or points.
       * @default "updated_at"
       */
      sort_by?: "updated_at" | "publish_date" | "name" | "points";
      /**
       * Sort direction. Values can be desc or asc. default: desc. NOTE: default is desc if sort_by is date otherwise asc
       * @default "desc"
       */
      sort_dir?: "asc" | "desc";
      /**
       * Offset page parameter
       * @default 1
       */
      page?: number;
      /**
       * Number of items per page
       * @default 15
       */
      per_page?: number;
    },
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/loyalty/offers")
        ? computed(() => mockPath("Consumer", "getLoyaltyOffers", ``))
        : computed(() => `/consumers-v3/consumer/loyalty/offers`),
      method: "GET",
      query: query,
      format: "json",
      key: `/consumers-v3/consumer/loyalty/offers`,
      apiName: "Consumer.getLoyaltyOffers",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyOffers
   * @summary Get Loyalty Offers
   * @request GET:/consumers-v3/consumer/loyalty/offers
   */
  $getLoyaltyOffers = (
    query?: {
      /** Internal name of a known Offer Set */
      set?: string;
      /** Internal name of a known Placement */
      placement?: string;
      /** Internal name of a known Campaign */
      campaign?: string;
      /** Whether the response should be paginated */
      pagination?: boolean;
      /** Start index of the available Offers subset. Used in conjunction with set. */
      start_index?: number;
      /** End index of the available Offers subset. Used in conjunction with set. */
      end_index?: number;
      /** Comma-separated string of category internal names of Offers to include in the response */
      category?: string;
      /** The content layout name. Default is the access token's application name. Example: ios, android */
      layout?: string;
      /** Return only matching offer_types based on offer_type parameter. Can be any of 'barcode', 'certificate', 'coupon', 'url' or 'stellar'. */
      offer_type?: "barcode" | "certificate" | "coupon" | "url" | "stellar";
      /** If set to true, only offers that can be responded to will be shown. */
      respondable?: boolean;
      /** If set to true, will show clipped and unclipped offers, false will show unclipped offers only */
      show_clipped?: boolean;
      /** If set to true, targetable attribute that holds a target offer object will be shown. */
      show_target?: boolean;
      /** Comma-separated string of processing status to be included in the response */
      displayable_processing_statuses?: string;
      /** If set to true, is_clipped attribute will be shown. */
      include_clipped?: boolean;
      /** If set to true, responses(Array) attribute that holds responses details will be shown. */
      include_responses?: boolean;
      /** Values can be true or false. This parameter will return the category keys of the offer in an array. */
      result_with_categories?: boolean;
      /** If set to true, html attribute that holds html layout will be shown. */
      html?: boolean;
      /**
       * Sort options. Values can be updated_at or publish_date or name or points.
       * @default "updated_at"
       */
      sort_by?: "updated_at" | "publish_date" | "name" | "points";
      /**
       * Sort direction. Values can be desc or asc. default: desc. NOTE: default is desc if sort_by is date otherwise asc
       * @default "desc"
       */
      sort_dir?: "asc" | "desc";
      /**
       * Offset page parameter
       * @default 1
       */
      page?: number;
      /**
       * Number of items per page
       * @default 15
       */
      per_page?: number;
    },
    requestParams: ApiOptions = {},
  ) =>
    this.$request<GetLoyaltyOffersData>({
      path: isMocked("/consumers-v3/consumer/loyalty/offers")
        ? mockPath("Consumer", "getLoyaltyOffers", ``)
        : `/consumers-v3/consumer/loyalty/offers`,
      method: "GET",
      query: query,
      format: "json",
      apiName: "Consumer.getLoyaltyOffers",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyReferrals
   * @summary Get Loyalty Referrals
   * @request GET:/consumers-v3/consumer/loyalty/referrals
   */
  getLoyaltyReferrals = <
    ResT = GetLoyaltyReferralsData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/loyalty/referrals")
        ? computed(() => mockPath("Consumer", "getLoyaltyReferrals", ``))
        : computed(() => `/consumers-v3/consumer/loyalty/referrals`),
      method: "GET",
      format: "json",
      key: `/consumers-v3/consumer/loyalty/referrals`,
      apiName: "Consumer.getLoyaltyReferrals",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyReferrals
   * @summary Get Loyalty Referrals
   * @request GET:/consumers-v3/consumer/loyalty/referrals
   */
  $getLoyaltyReferrals = (requestParams: ApiOptions = {}) =>
    this.$request<GetLoyaltyReferralsData>({
      path: isMocked("/consumers-v3/consumer/loyalty/referrals")
        ? mockPath("Consumer", "getLoyaltyReferrals", ``)
        : `/consumers-v3/consumer/loyalty/referrals`,
      method: "GET",
      format: "json",
      apiName: "Consumer.getLoyaltyReferrals",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyToken
   * @summary Get Loyalty Token
   * @request POST:/consumers-v3/consumer/loyalty/token
   */
  getLoyaltyToken = <
    ResT = GetLoyaltyTokenData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: GetLoyaltyTokenPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/loyalty/token")
        ? computed(() => mockPath("Consumer", "getLoyaltyToken", ``))
        : computed(() => `/consumers-v3/consumer/loyalty/token`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/loyalty/token`,
      apiName: "Consumer.getLoyaltyToken",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyToken
   * @summary Get Loyalty Token
   * @request POST:/consumers-v3/consumer/loyalty/token
   */
  $getLoyaltyToken = (
    data: GetLoyaltyTokenPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<GetLoyaltyTokenData>({
      path: isMocked("/consumers-v3/consumer/loyalty/token")
        ? mockPath("Consumer", "getLoyaltyToken", ``)
        : `/consumers-v3/consumer/loyalty/token`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.getLoyaltyToken",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyWelcomePromoStatus
   * @summary Get Loyalty Welcome Promo Status
   * @request GET:/consumers-v3/consumer/loyalty/promo/welcome
   */
  getLoyaltyWelcomePromoStatus = <
    ResT = GetLoyaltyWelcomePromoStatusData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/loyalty/promo/welcome")
        ? computed(() =>
            mockPath("Consumer", "getLoyaltyWelcomePromoStatus", ``),
          )
        : computed(() => `/consumers-v3/consumer/loyalty/promo/welcome`),
      method: "GET",
      format: "json",
      key: `/consumers-v3/consumer/loyalty/promo/welcome`,
      apiName: "Consumer.getLoyaltyWelcomePromoStatus",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyWelcomePromoStatus
   * @summary Get Loyalty Welcome Promo Status
   * @request GET:/consumers-v3/consumer/loyalty/promo/welcome
   */
  $getLoyaltyWelcomePromoStatus = (requestParams: ApiOptions = {}) =>
    this.$request<GetLoyaltyWelcomePromoStatusData>({
      path: isMocked("/consumers-v3/consumer/loyalty/promo/welcome")
        ? mockPath("Consumer", "getLoyaltyWelcomePromoStatus", ``)
        : `/consumers-v3/consumer/loyalty/promo/welcome`,
      method: "GET",
      format: "json",
      apiName: "Consumer.getLoyaltyWelcomePromoStatus",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyVouchers
   * @summary Get Loyalty Vouchers
   * @request GET:/consumers-v3/consumer/loyalty/vouchers
   */
  getLoyaltyVouchers = <
    ResT = GetLoyaltyVouchersData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/loyalty/vouchers")
        ? computed(() => mockPath("Consumer", "getLoyaltyVouchers", ``))
        : computed(() => `/consumers-v3/consumer/loyalty/vouchers`),
      method: "GET",
      format: "json",
      key: `/consumers-v3/consumer/loyalty/vouchers`,
      apiName: "Consumer.getLoyaltyVouchers",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetLoyaltyVouchers
   * @summary Get Loyalty Vouchers
   * @request GET:/consumers-v3/consumer/loyalty/vouchers
   */
  $getLoyaltyVouchers = (requestParams: ApiOptions = {}) =>
    this.$request<GetLoyaltyVouchersData>({
      path: isMocked("/consumers-v3/consumer/loyalty/vouchers")
        ? mockPath("Consumer", "getLoyaltyVouchers", ``)
        : `/consumers-v3/consumer/loyalty/vouchers`,
      method: "GET",
      format: "json",
      apiName: "Consumer.getLoyaltyVouchers",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name Lookup
   * @summary Lookup for Existing User
   * @request POST:/consumers-v3/consumer/lookup
   */
  lookup = <
    ResT = LookupData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: LookupPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/lookup")
        ? computed(() => mockPath("Consumer", "lookup", ``))
        : computed(() => `/consumers-v3/consumer/lookup`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/lookup`,
      apiName: "Consumer.lookup",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name Lookup
   * @summary Lookup for Existing User
   * @request POST:/consumers-v3/consumer/lookup
   */
  $lookup = (data: LookupPayload, requestParams: ApiOptions = {}) =>
    this.$request<LookupData>({
      path: isMocked("/consumers-v3/consumer/lookup")
        ? mockPath("Consumer", "lookup", ``)
        : `/consumers-v3/consumer/lookup`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.lookup",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetSmsSubscriptionInfo
   * @summary Get SMS Subscription
   * @request GET:/consumers-v3/consumer/subscription
   */
  getSmsSubscriptionInfo = <
    ResT = GetSmsSubscriptionInfoData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/subscription")
        ? computed(() => mockPath("Consumer", "getSmsSubscriptionInfo", ``))
        : computed(() => `/consumers-v3/consumer/subscription`),
      method: "GET",
      format: "json",
      key: `/consumers-v3/consumer/subscription`,
      apiName: "Consumer.getSmsSubscriptionInfo",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetSmsSubscriptionInfo
   * @summary Get SMS Subscription
   * @request GET:/consumers-v3/consumer/subscription
   */
  $getSmsSubscriptionInfo = (requestParams: ApiOptions = {}) =>
    this.$request<GetSmsSubscriptionInfoData>({
      path: isMocked("/consumers-v3/consumer/subscription")
        ? mockPath("Consumer", "getSmsSubscriptionInfo", ``)
        : `/consumers-v3/consumer/subscription`,
      method: "GET",
      format: "json",
      apiName: "Consumer.getSmsSubscriptionInfo",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name UpdateSmsSubscription
   * @summary Update SMS Subscription
   * @request PUT:/consumers-v3/consumer/subscription
   */
  updateSmsSubscription = <
    ResT = UpdateSmsSubscriptionData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: ProfileInfoPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/subscription")
        ? computed(() => mockPath("Consumer", "updateSmsSubscription", ``))
        : computed(() => `/consumers-v3/consumer/subscription`),
      method: "PUT",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/subscription`,
      apiName: "Consumer.updateSmsSubscription",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name UpdateSmsSubscription
   * @summary Update SMS Subscription
   * @request PUT:/consumers-v3/consumer/subscription
   */
  $updateSmsSubscription = (
    data: ProfileInfoPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<UpdateSmsSubscriptionData>({
      path: isMocked("/consumers-v3/consumer/subscription")
        ? mockPath("Consumer", "updateSmsSubscription", ``)
        : `/consumers-v3/consumer/subscription`,
      method: "PUT",
      body: data,
      format: "json",
      apiName: "Consumer.updateSmsSubscription",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name CreateSmsSubscription
   * @summary Create SMS Subscription
   * @request POST:/consumers-v3/consumer/subscription
   */
  createSmsSubscription = <
    ResT = CreateSmsSubscriptionData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: ProfileInfoPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/subscription")
        ? computed(() => mockPath("Consumer", "createSmsSubscription", ``))
        : computed(() => `/consumers-v3/consumer/subscription`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/subscription`,
      apiName: "Consumer.createSmsSubscription",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name CreateSmsSubscription
   * @summary Create SMS Subscription
   * @request POST:/consumers-v3/consumer/subscription
   */
  $createSmsSubscription = (
    data: ProfileInfoPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<CreateSmsSubscriptionData>({
      path: isMocked("/consumers-v3/consumer/subscription")
        ? mockPath("Consumer", "createSmsSubscription", ``)
        : `/consumers-v3/consumer/subscription`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.createSmsSubscription",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetPaymentInstruments
   * @summary Get Saved Payment Instruments
   * @request GET:/consumers-v3/consumer/payment_instruments
   */
  getPaymentInstruments = <
    ResT = GetPaymentInstrumentsData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    query?: {
      /** The ID of the basket */
      payment_method_id?: string;
    },
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/payment_instruments")
        ? computed(() => mockPath("Consumer", "getPaymentInstruments", ``))
        : computed(() => `/consumers-v3/consumer/payment_instruments`),
      method: "GET",
      query: query,
      format: "json",
      key: `/consumers-v3/consumer/payment_instruments`,
      apiName: "Consumer.getPaymentInstruments",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetPaymentInstruments
   * @summary Get Saved Payment Instruments
   * @request GET:/consumers-v3/consumer/payment_instruments
   */
  $getPaymentInstruments = (
    query?: {
      /** The ID of the basket */
      payment_method_id?: string;
    },
    requestParams: ApiOptions = {},
  ) =>
    this.$request<GetPaymentInstrumentsData>({
      path: isMocked("/consumers-v3/consumer/payment_instruments")
        ? mockPath("Consumer", "getPaymentInstruments", ``)
        : `/consumers-v3/consumer/payment_instruments`,
      method: "GET",
      query: query,
      format: "json",
      apiName: "Consumer.getPaymentInstruments",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name SavePaymentInstrument
   * @summary Save Payment Instrument
   * @request POST:/consumers-v3/consumer/payment_instruments
   */
  savePaymentInstrument = <
    ResT = SavePaymentInstrumentData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: SavePaymentInstrumentPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/payment_instruments")
        ? computed(() => mockPath("Consumer", "savePaymentInstrument", ``))
        : computed(() => `/consumers-v3/consumer/payment_instruments`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/payment_instruments`,
      apiName: "Consumer.savePaymentInstrument",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name SavePaymentInstrument
   * @summary Save Payment Instrument
   * @request POST:/consumers-v3/consumer/payment_instruments
   */
  $savePaymentInstrument = (
    data: SavePaymentInstrumentPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<SavePaymentInstrumentData>({
      path: isMocked("/consumers-v3/consumer/payment_instruments")
        ? mockPath("Consumer", "savePaymentInstrument", ``)
        : `/consumers-v3/consumer/payment_instruments`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.savePaymentInstrument",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name UpdatePaymentInstrument
   * @summary Update Payment Instrument
   * @request PATCH:/consumers-v3/consumer/payment_instruments/{payment_instrument_id}
   */
  updatePaymentInstrument = <
    ResT = UpdatePaymentInstrumentData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    paymentInstrumentId: MaybeRefOrGetter<string>,
    data: UpdatePaymentInstrumentPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked(
        "/consumers-v3/consumer/payment_instruments/:paymentInstrumentId",
      )
        ? computed(() =>
            mockPath(
              "Consumer",
              "updatePaymentInstrument",
              `paymentInstrumentId:${toValue(paymentInstrumentId)}`,
            ),
          )
        : computed(
            () =>
              `/consumers-v3/consumer/payment_instruments/${toValue(paymentInstrumentId)}`,
          ),
      method: "PATCH",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/payment_instruments/${toValue(paymentInstrumentId)}`,
      apiName: "Consumer.updatePaymentInstrument",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name UpdatePaymentInstrument
   * @summary Update Payment Instrument
   * @request PATCH:/consumers-v3/consumer/payment_instruments/{payment_instrument_id}
   */
  $updatePaymentInstrument = (
    paymentInstrumentId: string,
    data: UpdatePaymentInstrumentPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<UpdatePaymentInstrumentData>({
      path: isMocked(
        "/consumers-v3/consumer/payment_instruments/:paymentInstrumentId",
      )
        ? mockPath(
            "Consumer",
            "updatePaymentInstrument",
            `paymentInstrumentId:${toValue(paymentInstrumentId)}`,
          )
        : `/consumers-v3/consumer/payment_instruments/${paymentInstrumentId}`,
      method: "PATCH",
      body: data,
      format: "json",
      apiName: "Consumer.updatePaymentInstrument",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name DeletePaymentInstrument
   * @summary Delete Payment Instrument
   * @request DELETE:/consumers-v3/consumer/payment_instruments/{payment_instrument_id}
   */
  deletePaymentInstrument = <
    ResT = DeletePaymentInstrumentData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    paymentInstrumentId: MaybeRefOrGetter<string>,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked(
        "/consumers-v3/consumer/payment_instruments/:paymentInstrumentId",
      )
        ? computed(() =>
            mockPath(
              "Consumer",
              "deletePaymentInstrument",
              `paymentInstrumentId:${toValue(paymentInstrumentId)}`,
            ),
          )
        : computed(
            () =>
              `/consumers-v3/consumer/payment_instruments/${toValue(paymentInstrumentId)}`,
          ),
      method: "DELETE",
      format: "json",
      key: `/consumers-v3/consumer/payment_instruments/${toValue(paymentInstrumentId)}`,
      apiName: "Consumer.deletePaymentInstrument",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name DeletePaymentInstrument
   * @summary Delete Payment Instrument
   * @request DELETE:/consumers-v3/consumer/payment_instruments/{payment_instrument_id}
   */
  $deletePaymentInstrument = (
    paymentInstrumentId: string,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<DeletePaymentInstrumentData>({
      path: isMocked(
        "/consumers-v3/consumer/payment_instruments/:paymentInstrumentId",
      )
        ? mockPath(
            "Consumer",
            "deletePaymentInstrument",
            `paymentInstrumentId:${toValue(paymentInstrumentId)}`,
          )
        : `/consumers-v3/consumer/payment_instruments/${paymentInstrumentId}`,
      method: "DELETE",
      format: "json",
      apiName: "Consumer.deletePaymentInstrument",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetOrderDetails
   * @summary Get Order Details
   * @request GET:/consumers-v3/consumer/purchase/{orderId}
   */
  getOrderDetails = <
    ResT = GetOrderDetailsData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    orderId: MaybeRefOrGetter<string>,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/purchase/:orderId")
        ? computed(() =>
            mockPath(
              "Consumer",
              "getOrderDetails",
              `orderId:${toValue(orderId)}`,
            ),
          )
        : computed(() => `/consumers-v3/consumer/purchase/${toValue(orderId)}`),
      method: "GET",
      format: "json",
      key: `/consumers-v3/consumer/purchase/${toValue(orderId)}`,
      apiName: "Consumer.getOrderDetails",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetOrderDetails
   * @summary Get Order Details
   * @request GET:/consumers-v3/consumer/purchase/{orderId}
   */
  $getOrderDetails = (orderId: string, requestParams: ApiOptions = {}) =>
    this.$request<GetOrderDetailsData>({
      path: isMocked("/consumers-v3/consumer/purchase/:orderId")
        ? mockPath("Consumer", "getOrderDetails", `orderId:${toValue(orderId)}`)
        : `/consumers-v3/consumer/purchase/${orderId}`,
      method: "GET",
      format: "json",
      apiName: "Consumer.getOrderDetails",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name InvoiceDownload
   * @summary Invoice Download
   * @request POST:/consumers-v3/consumer/purchase/invoice/download
   */
  invoiceDownload = <
    ResT = InvoiceDownloadData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: InvoiceDownloadPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/purchase/invoice/download")
        ? computed(() => mockPath("Consumer", "invoiceDownload", ``))
        : computed(() => `/consumers-v3/consumer/purchase/invoice/download`),
      method: "POST",
      body: data,
      key: `/consumers-v3/consumer/purchase/invoice/download`,
      apiName: "Consumer.invoiceDownload",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name InvoiceDownload
   * @summary Invoice Download
   * @request POST:/consumers-v3/consumer/purchase/invoice/download
   */
  $invoiceDownload = (
    data: InvoiceDownloadPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<InvoiceDownloadData>({
      path: isMocked("/consumers-v3/consumer/purchase/invoice/download")
        ? mockPath("Consumer", "invoiceDownload", ``)
        : `/consumers-v3/consumer/purchase/invoice/download`,
      method: "POST",
      body: data,
      apiName: "Consumer.invoiceDownload",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetOrderHistory
   * @summary Get Order History
   * @request POST:/consumers-v3/consumer/purchasehistory
   */
  getOrderHistory = <
    ResT = GetOrderHistoryData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: GetOrderHistoryPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/purchasehistory")
        ? computed(() => mockPath("Consumer", "getOrderHistory", ``))
        : computed(() => `/consumers-v3/consumer/purchasehistory`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/purchasehistory`,
      apiName: "Consumer.getOrderHistory",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name GetOrderHistory
   * @summary Get Order History
   * @request POST:/consumers-v3/consumer/purchasehistory
   */
  $getOrderHistory = (
    data: GetOrderHistoryPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<GetOrderHistoryData>({
      path: isMocked("/consumers-v3/consumer/purchasehistory")
        ? mockPath("Consumer", "getOrderHistory", ``)
        : `/consumers-v3/consumer/purchasehistory`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.getOrderHistory",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name ReturnLabel
   * @summary Return Label
   * @request POST:/consumers-v3/consumer/return/{orderId}/returnLabel
   */
  returnLabel = <
    ResT = ReturnLabelData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    orderId: MaybeRefOrGetter<string>,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/return/:orderId/returnLabel")
        ? computed(() =>
            mockPath("Consumer", "returnLabel", `orderId:${toValue(orderId)}`),
          )
        : computed(
            () =>
              `/consumers-v3/consumer/return/${toValue(orderId)}/returnLabel`,
          ),
      method: "POST",
      format: "json",
      key: `/consumers-v3/consumer/return/${toValue(orderId)}/returnLabel`,
      apiName: "Consumer.returnLabel",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name ReturnLabel
   * @summary Return Label
   * @request POST:/consumers-v3/consumer/return/{orderId}/returnLabel
   */
  $returnLabel = (orderId: string, requestParams: ApiOptions = {}) =>
    this.$request<ReturnLabelData>({
      path: isMocked("/consumers-v3/consumer/return/:orderId/returnLabel")
        ? mockPath("Consumer", "returnLabel", `orderId:${toValue(orderId)}`)
        : `/consumers-v3/consumer/return/${orderId}/returnLabel`,
      method: "POST",
      format: "json",
      apiName: "Consumer.returnLabel",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name TrackOrder
   * @summary Track Order
   * @request POST:/consumers-v3/consumer/TrackOrder
   */
  trackOrder = <
    ResT = TrackOrderData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: TrackOrderPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/TrackOrder")
        ? computed(() => mockPath("Consumer", "trackOrder", ``))
        : computed(() => `/consumers-v3/consumer/TrackOrder`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/TrackOrder`,
      apiName: "Consumer.trackOrder",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name TrackOrder
   * @summary Track Order
   * @request POST:/consumers-v3/consumer/TrackOrder
   */
  $trackOrder = (data: TrackOrderPayload, requestParams: ApiOptions = {}) =>
    this.$request<TrackOrderData>({
      path: isMocked("/consumers-v3/consumer/TrackOrder")
        ? mockPath("Consumer", "trackOrder", ``)
        : `/consumers-v3/consumer/TrackOrder`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.trackOrder",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name AddAddress
   * @summary Add Address
   * @request POST:/consumers-v3/consumer/address
   */
  addAddress = <
    ResT = AddAddressData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: AddAddressPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/address")
        ? computed(() => mockPath("Consumer", "addAddress", ``))
        : computed(() => `/consumers-v3/consumer/address`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/address`,
      apiName: "Consumer.addAddress",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name AddAddress
   * @summary Add Address
   * @request POST:/consumers-v3/consumer/address
   */
  $addAddress = (data: AddAddressPayload, requestParams: ApiOptions = {}) =>
    this.$request<AddAddressData>({
      path: isMocked("/consumers-v3/consumer/address")
        ? mockPath("Consumer", "addAddress", ``)
        : `/consumers-v3/consumer/address`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.addAddress",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name UpdateAddress
   * @summary Update Address
   * @request PUT:/consumers-v3/consumer/address/{addressId}
   */
  updateAddress = <
    ResT = UpdateAddressData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    addressId: MaybeRefOrGetter<string>,
    data: UpdateAddressPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/address/:addressId")
        ? computed(() =>
            mockPath(
              "Consumer",
              "updateAddress",
              `addressId:${toValue(addressId)}`,
            ),
          )
        : computed(
            () => `/consumers-v3/consumer/address/${toValue(addressId)}`,
          ),
      method: "PUT",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/address/${toValue(addressId)}`,
      apiName: "Consumer.updateAddress",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name UpdateAddress
   * @summary Update Address
   * @request PUT:/consumers-v3/consumer/address/{addressId}
   */
  $updateAddress = (
    addressId: string,
    data: UpdateAddressPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<UpdateAddressData>({
      path: isMocked("/consumers-v3/consumer/address/:addressId")
        ? mockPath(
            "Consumer",
            "updateAddress",
            `addressId:${toValue(addressId)}`,
          )
        : `/consumers-v3/consumer/address/${addressId}`,
      method: "PUT",
      body: data,
      format: "json",
      apiName: "Consumer.updateAddress",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name DeleteAddress
   * @summary Delete Address
   * @request DELETE:/consumers-v3/consumer/address/{addressId}
   */
  deleteAddress = <
    ResT = DeleteAddressData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    addressId: MaybeRefOrGetter<string>,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/address/:addressId")
        ? computed(() =>
            mockPath(
              "Consumer",
              "deleteAddress",
              `addressId:${toValue(addressId)}`,
            ),
          )
        : computed(
            () => `/consumers-v3/consumer/address/${toValue(addressId)}`,
          ),
      method: "DELETE",
      format: "json",
      key: `/consumers-v3/consumer/address/${toValue(addressId)}`,
      apiName: "Consumer.deleteAddress",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name DeleteAddress
   * @summary Delete Address
   * @request DELETE:/consumers-v3/consumer/address/{addressId}
   */
  $deleteAddress = (addressId: string, requestParams: ApiOptions = {}) =>
    this.$request<DeleteAddressData>({
      path: isMocked("/consumers-v3/consumer/address/:addressId")
        ? mockPath(
            "Consumer",
            "deleteAddress",
            `addressId:${toValue(addressId)}`,
          )
        : `/consumers-v3/consumer/address/${addressId}`,
      method: "DELETE",
      format: "json",
      apiName: "Consumer.deleteAddress",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name CancelOrder
   * @summary Cancel Order
   * @request POST:/consumers-v3/consumer/CancelOrder
   */
  cancelOrder = <
    ResT = CancelOrderData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: CancelOrderPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/CancelOrder")
        ? computed(() => mockPath("Consumer", "cancelOrder", ``))
        : computed(() => `/consumers-v3/consumer/CancelOrder`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/CancelOrder`,
      apiName: "Consumer.cancelOrder",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name CancelOrder
   * @summary Cancel Order
   * @request POST:/consumers-v3/consumer/CancelOrder
   */
  $cancelOrder = (data: CancelOrderPayload, requestParams: ApiOptions = {}) =>
    this.$request<CancelOrderData>({
      path: isMocked("/consumers-v3/consumer/CancelOrder")
        ? mockPath("Consumer", "cancelOrder", ``)
        : `/consumers-v3/consumer/CancelOrder`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.cancelOrder",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name ResendGiftcardEmail
   * @summary Resend Giftcard Email
   * @request POST:/consumers-v3/consumer/resendGiftCardEmail
   */
  resendGiftcardEmail = <
    ResT = ResendGiftcardEmailData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: ResendGiftcardEmailPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/resendGiftCardEmail")
        ? computed(() => mockPath("Consumer", "resendGiftcardEmail", ``))
        : computed(() => `/consumers-v3/consumer/resendGiftCardEmail`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/resendGiftCardEmail`,
      apiName: "Consumer.resendGiftcardEmail",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name ResendGiftcardEmail
   * @summary Resend Giftcard Email
   * @request POST:/consumers-v3/consumer/resendGiftCardEmail
   */
  $resendGiftcardEmail = (
    data: ResendGiftcardEmailPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<ResendGiftcardEmailData>({
      path: isMocked("/consumers-v3/consumer/resendGiftCardEmail")
        ? mockPath("Consumer", "resendGiftcardEmail", ``)
        : `/consumers-v3/consumer/resendGiftCardEmail`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.resendGiftcardEmail",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name RetrieveUserData
   * @summary Retrieve User Data
   * @request POST:/consumers-v3/consumer/retrieveUserData
   */
  retrieveUserData = <
    ResT = RetrieveUserDataData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: RetrieveUserDataPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/retrieveUserData")
        ? computed(() => mockPath("Consumer", "retrieveUserData", ``))
        : computed(() => `/consumers-v3/consumer/retrieveUserData`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/retrieveUserData`,
      apiName: "Consumer.retrieveUserData",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name RetrieveUserData
   * @summary Retrieve User Data
   * @request POST:/consumers-v3/consumer/retrieveUserData
   */
  $retrieveUserData = (
    data: RetrieveUserDataPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<RetrieveUserDataData>({
      path: isMocked("/consumers-v3/consumer/retrieveUserData")
        ? mockPath("Consumer", "retrieveUserData", ``)
        : `/consumers-v3/consumer/retrieveUserData`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.retrieveUserData",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name NotifyMobile
   * @summary Notify Users on Mobile when item is back in stock
   * @request PUT:/consumers-v3/consumer/notification
   */
  notifyMobile = <
    ResT = NotifyMobileData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: NotifyMobilePayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/notification")
        ? computed(() => mockPath("Consumer", "notifyMobile", ``))
        : computed(() => `/consumers-v3/consumer/notification`),
      method: "PUT",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/notification`,
      apiName: "Consumer.notifyMobile",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name NotifyMobile
   * @summary Notify Users on Mobile when item is back in stock
   * @request PUT:/consumers-v3/consumer/notification
   */
  $notifyMobile = (data: NotifyMobilePayload, requestParams: ApiOptions = {}) =>
    this.$request<NotifyMobileData>({
      path: isMocked("/consumers-v3/consumer/notification")
        ? mockPath("Consumer", "notifyMobile", ``)
        : `/consumers-v3/consumer/notification`,
      method: "PUT",
      body: data,
      format: "json",
      apiName: "Consumer.notifyMobile",
      mobileAppTracking: "false",
      ...requestParams,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name EventRegistrationData
   * @summary Event Registration Data
   * @request POST:/consumers-v3/consumer/event-registration
   */
  eventRegistrationData = <
    ResT = EventRegistrationDataData,
    DataT = ResT,
    PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
    DefaultT = null,
  >(
    data: EventRegistrationDataPayload,
    params: UseApiOptions<ResT, DataT, PickKeys, DefaultT> = {},
  ) =>
    this.request<ResT, DataT, PickKeys, DefaultT>({
      path: isMocked("/consumers-v3/consumer/event-registration")
        ? computed(() => mockPath("Consumer", "eventRegistrationData", ``))
        : computed(() => `/consumers-v3/consumer/event-registration`),
      method: "POST",
      body: data,
      format: "json",
      key: `/consumers-v3/consumer/event-registration`,
      apiName: "Consumer.eventRegistrationData",
      mobileAppTracking: "false",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consumer
   * @name EventRegistrationData
   * @summary Event Registration Data
   * @request POST:/consumers-v3/consumer/event-registration
   */
  $eventRegistrationData = (
    data: EventRegistrationDataPayload,
    requestParams: ApiOptions = {},
  ) =>
    this.$request<EventRegistrationDataData>({
      path: isMocked("/consumers-v3/consumer/event-registration")
        ? mockPath("Consumer", "eventRegistrationData", ``)
        : `/consumers-v3/consumer/event-registration`,
      method: "POST",
      body: data,
      format: "json",
      apiName: "Consumer.eventRegistrationData",
      mobileAppTracking: "false",
      ...requestParams,
    });
}
